import HomeIcon from "@/assets/icons/HomeIcon.svg";
import InsightsIcon from "@/assets/icons/AnalyticsIcon.svg";
import PatientPathIcon from "@/assets/icons/PatientPathIcon.svg";
import LearningIcon from "@/assets/icons/LearningHubIcon.svg";
import SettingsIcon from "@/assets/icons/Settings.svg";
import ProfileIcon from "@/assets/icons/ProfileIcon.svg";
import LogoutIcon from "@/assets/icons/LogoutIcon.svg";

export interface INavItem {
  text: string;
  icon: {
    src: string;
  };
  route: string;
  name: string;
  license?: string;
  licensedRoute?: string;
}

export const insightsLinks = [
  {
    text: "headNav.velysInsights.workflowEfficiency",
    route: "/provider/insights/workflow",
    name: "workflow",
  },
  {
    text: "headNav.velysInsights.technique",
    route: "/provider/insights/technique",
    name: "technique",
  },
  {
    text: "headNav.velysInsights.patientOutcomes",
    route: "/provider/insights/outcomes",
    name: "outcomes",
  },
  {
    text: "headNav.velysInsights.caseInformation",
    route: "/provider/insights/cases",
    name: "cases",
  },
];

export const patientPathLinks = [
  {
    text: "headNav.velysPatientPath.patientInfo",
    route: "info",
    name: "info",
  },
  {
    text: "headNav.velysPatientPath.carePlan",
    route: "plan",
    name: "plan",
  },
  {
    text: "headNav.velysPatientPath.postOpMonitoring",
    route: "metrics",
    name: "metrics",
  },
  {
    text: "headNav.velysPatientPath.patientCaseReport",
    route: "vras",
    name: "vras",
  },
];

export const settingsLinks = [
  {
    text: "headNav.userProfile.profile",
    route: "/provider/settings/profile",
    name: "profile",
    icon: ProfileIcon,
  },
  {
    text: "headNav.logout",
    route: "/", // will eventually be changed
    name: "logout",
    icon: LogoutIcon,
  },
];

export const subSettingsLinks = [
  {
    text: "headNav.userProfile.profile",
    route: "/provider/settings/profile",
    name: "profile",
    icon: ProfileIcon,
  },
  {
    text: "headNav.userProfile.predefinedActionItems",
    route: "/provider/settings/predefined-action-items",
    name: "predefined-action-items",
    icon: ProfileIcon,
  },
  {
    text: "headNav.userProfile.carePlanSettings",
    route: "/provider/settings/care-plan",
    name: "care-plan",
    icon: ProfileIcon,
  },
  {
    text: "headNav.userProfile.practiceManagement",
    route: "/provider/settings/practice-management",
    name: "practice-management",
    icon: ProfileIcon,
  },
];

export const mobileSettingsLink = [
  ...subSettingsLinks,
  {
    text: "headNav.logout",
    route: "/", // will eventually be changed
    name: "logout",
    icon: LogoutIcon,
  },
];

export const navItems = [
  {
    text: "headNav.home",
    icon: HomeIcon,
    route: "/provider/overview",
    name: "overview",
  },
  {
    text: "headNav.velysInsights.insights",
    icon: InsightsIcon,
    route: "/provider/insights/workflow",
    licensedRoute: "/provider/insights/cases",
    name: "insights",
    subItems: insightsLinks,
    license: "jnj.velys.insights",
  },
  {
    text: "headNav.velysPatientPath.patientPath",
    icon: PatientPathIcon,
    route: "/provider/patientpath",
    licensedRoute: "/provider/patientpath",
    name: "patientpath",
    subItems: patientPathLinks,
    license: "jnj.velys.patientpath",
  },
  {
    text: "headNav.learningHub",
    icon: LearningIcon,
    route: "/provider/learning",
    name: "learning",
  },
  {
    text: "headNav.settings",
    icon: SettingsIcon,
    route: "/provider/settings",
    name: "settings",
    subItems: settingsLinks,
  },
];

export const footerItems = [
  {
    text: "footer.privacy",
    name: "privacy",
  },
  {
    text: "footer.cookieSettings",
    name: "cookie-policy",
  },
  {
    text: "footer.contactUs",
    name: "contact",
  },
  {
    text: "footer.doNotSellShare",
    name: "do-not-sell-share",
  },
  {
    text: "footer.copyright",
    name: "copyright",
  },
];

export const patientFooterItems = [
  {
    text: "footer.privacy",
    name: "privacy",
  },
  {
    text: "footer.cookieSettings",
    name: "cookie-policy",
  },
  {
    text: "footer.healthcareTeam",
    name: "healthcare-team",
  },
  {
    text: "footer.productSupport",
    name: "product-support",
  },
  {
    text: "footer.doNotSellShare",
    name: "do-not-sell-share",
  },
  {
    text: "footer.copyright",
    name: "copyright",
  },
];
